// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._195gutpp{margin-inline:var(--ds-space-150,9pt)}\n._1mouu2gc{margin-block:var(--ds-space-100,8px)}._15a5nqa1{border-top-style:solid}\n._1i53b5v6{border-top-color:var(--ds-border,#dfe1e6)}\n._ca0q1b66{padding-top:var(--ds-space-050,4px)}\n._n3td1b66{padding-bottom:var(--ds-space-050,4px)}\n._syaz131l{color:var(--ds-text-subtlest,#626f86)}\n._uwhke4h9{border-top-width:var(--ds-border-width,1px)}", ""]);
// Exports
module.exports = exports;
